import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IteratorUtils {

  public static iterableSize(it: IterableIterator<any>): number {
    return Array.from(it).length;
  }
}

